'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBatteryUnknown = function MdBatteryUnknown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.8 21.2c0.7-0.7 1.2-1.7 1.2-2.8 0-2.8-2.3-5-5-5s-5 2.2-5 5h2.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 0.7-0.2 1.2-0.7 1.7l-1.6 1.5c-0.7 0.8-1.5 2-1.5 3.4h2.6c0-0.8 0.7-1.9 1.4-2.7 0.5-0.4 1.1-1.1 1.1-1.1z m-2.2 8.7v-3.2h-3.2v3.2h3.2z m4.5-23.3c1.2 0 2.3 1.1 2.3 2.3v25.6c0 1.2-1.1 2.1-2.3 2.1h-12.2c-1.2 0-2.3-0.9-2.3-2.1v-25.6c0-1.2 1.1-2.3 2.3-2.3h2.7v-3.2h6.8v3.2h2.7z' })
        )
    );
};

exports.default = MdBatteryUnknown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/battery-unknown.js
// module id = 2639
// module chunks = 0